import { render } from "./GameStateStart.vue?vue&type=template&id=57e7b628&scoped=true"
import script from "./GameStateStart.vue?vue&type=script&lang=js"
export * from "./GameStateStart.vue?vue&type=script&lang=js"

import "./GameStateStart.vue?vue&type=style&index=0&id=57e7b628&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e7b628"]])

export default __exports__